import Vue3Lottie from 'vue3-lottie'

export default function (app) {
  app.use(Vue3Lottie, {
    name: 'Vue3Lottie'
  })
}
